import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';

@Component({
    selector: 'app-accounts-list-period-setup-list',
    templateUrl: './../../../templates/forms/modals/account-list-period-setup.component.html',
})
export class AccountsListPeriodSetupComponent implements OnInit {

    @Input()
    config: any;

    @Input()
    modalShow: boolean = true;

    @Input()
    accountShowForCostCenterForQJ;

    @Input()
    ACC_NO;

    @Output()
    submit: EventEmitter<any> = new EventEmitter<any>();

    dataObj: any;

    columnDefs = [];
    colObj;
    grid: any;
    gridId: string = "AccountsListPeriodSetupGrid"

    chartOfAccountList: any[] = [];
    searchFields: any[] = ['ACC_NAME', 'ACC_NO'];
    public searchString;
    constructor(private dataService: CommonService,
        public langService: LangService,
        public gridService: GridService) {
        this.colObj = [
            { headerName: langService.langData.accountName, field: 'ACC_NAME', sortable: true, resizable: true, hide: false },
            { headerName: langService.langData.accCode, field: 'ACC_CODE', sortable: true, resizable: true, hide: false },
            { headerName: langService.langData.accNo, field: 'ACC_NO', sortable: true, resizable: true, hide: false },
        ];
    }

    ngOnInit() {
        this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
    }
    onGridReady(grid) {
        this.grid = grid;
        this.gridService.sizeColumnsToFit(grid, this.gridId);
        if (this.accountShowForCostCenterForQJ) {
            this.dataService.getChartOfAccounts(fixedValues.queryOptions.CoaForQJ, this.ACC_NO)
                .subscribe(arg => { this.chartOfAccountList = arg.body });
        } else {
            this.dataService.getChartOfAccounts(fixedValues.queryOptions.CoaForCSOB)
                .subscribe(arg => { this.chartOfAccountList = arg.body });
        }
    }
    itemClick(_item) {
        this.modalShow = false;
        this.dataObj = _item;
        this.submit.next();
    }

}
